var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 495.787 495.787",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.893 0C110.986 0 0 110.986 0 247.893s110.986 247.893 247.893 247.893S495.786 384.8 495.786 247.893C495.552 111.083 384.704.235 247.893 0zm0 474.453c-125.126 0-226.56-101.434-226.56-226.56s101.434-226.56 226.56-226.56 226.56 101.434 226.56 226.56c-.234 125.029-101.531 226.326-226.56 226.56z",
    fill: "#3c0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.501 208.856a38.452 38.452 0 0 0-1.074-.003h-108.16v-23.04c-.059-28.513 23.008-51.674 51.52-51.733a51.628 51.628 0 0 1 45.12 26.346c2.887 5.243 9.477 7.153 14.72 4.267s7.153-9.477 4.267-14.72c-19.771-35.111-64.262-47.545-99.373-27.774a72.962 72.962 0 0 0-37.161 63.614v26.667a38.827 38.827 0 0 0-23.04 35.413v96c0 21.443 17.383 38.827 38.827 38.827h113.28c21.395-.117 38.71-17.432 38.827-38.827v-96c.354-21.204-16.548-38.682-37.753-39.037zm16.419 39.037v96.213c0 9.661-7.832 17.493-17.493 17.493h-113.28c-9.661 0-17.493-7.832-17.493-17.493v-96.213c0-9.661 7.832-17.493 17.493-17.493h113.28c9.543-.119 17.375 7.521 17.493 17.064.002.143.002.286 0 .429z",
    fill: "#3c0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.893 264.32c-9.615-.003-17.475 7.668-17.707 17.28a17.065 17.065 0 0 0 7.04 13.653v21.333c0 5.891 4.776 10.667 10.667 10.667s10.667-4.776 10.667-10.667v-21.333a17.278 17.278 0 0 0 6.613-13.44c.001-9.578-7.702-17.376-17.28-17.493z",
    fill: "#3c0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockRound);
export default __webpack_public_path__ + "static/media/unlock-round.d51d5f1547e04396ad136ac3f2231453.svg";
export { ForwardRef as ReactComponent };